"use client";
import Footer from "@/components/layout/footer";
import Header from "@/components/layout/header";
import { StartChatButon } from "@/components/ui/StartChatButon";
import React, { ReactNode } from "react";

interface LayoutWrapperProps {
  children: ReactNode;
}
const LayoutWrapper = ({ children }: LayoutWrapperProps) => {
  return (
    <div className="w-full pt-16 md:pt-20 pb-20 md:pb-0 min-h-screen max-w-screen-2xl sm:max-w-screen-2xl md:max-w-screen-xl mx-auto relative">
      <Header />
      {children}
      <StartChatButon />
      <div className="hidden md:block">
        <Footer />
      </div>
    </div>
  );
};

export default LayoutWrapper;
